/**
 * RoleBadge — the RM / Non-RM chip, in ONE place.
 *
 * It sits beside `UserLabel` deliberately: those two components are the whole
 * answer to "who is this person" on a table of people, and a tab that renders
 * one of them without the other, or renders a lookalike of either, is how two
 * tables end up describing the same person differently. Engagement and Inbox
 * both import this; the Quality tab still carries a byte-identical private
 * copy and should adopt this one when it is next touched.
 *
 * BINARY, and that is a decision rather than an omission. The roster
 * (`user_role_cache`) answers three things about a person — an RM, not an RM,
 * or nobody we hold a row for — and the backend collapses the third into
 * 'non-rm' before the wire (`TopUserRow.role` bug #6, `InboxUserRow.role`).
 * A SPLIT of a population has to put every row in one of two buckets, so
 * "unknown" is not on offer here. The three-state badge belongs to the user
 * DRILL-DOWN (`UserProfileHeader` / `UserDetail`), which describes one named
 * person and can honestly say it does not know.
 */

import * as React from 'react';

import { Badge } from '@/components/ui/badge';
import type { TopUsersRole } from '@/services/api-types';

export function RoleBadge({
  role,
}: {
  role: TopUsersRole;
}): React.ReactElement {
  if (role === 'rm') {
    return (
      <Badge className="bg-green-600 text-white hover:bg-green-600/80">
        RM
      </Badge>
    );
  }
  return (
    <Badge variant="secondary" className="bg-blue-100 text-blue-900">
      Non-RM
    </Badge>
  );
}
